var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "house_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".house_svg__st0{fill:none;stroke:#231f20;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "house_svg__st0",
    d: "m23.7 56.7 40.6-29.1 40 29.1M38.6 43.9V27.6h9.1v10.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "house_svg__st0",
    d: "M28.6 53.7v47.4h70.8v-46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "house_svg__st0",
    d: "M56.2 101.1V70.2h14.5v30.9"
  })));
};
export default SvgHouse;